import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import portal from "@vacancorp/portal";
import Vue from "vue";
import { hasAccessToken } from "@/usecase/token-operators";
import { createFavoritePlace, deleteFavoritePlace } from "@/api/adapter.api";

export default Vue.extend({
  name: "mixin-favorite",
  data() {
    return {
      isFavoriteOn: false,
      showFavoriteBtn: true,
      showFavoriteAnime: false,
      playFavoriteOnAnime: false,
      playFavoriteOffAnime: false,
    };
  },
  methods: {
    setIsFavoriteOn(payload: boolean) {
      this.isFavoriteOn = payload;
    },
    setShowFavoriteBtn(payload: boolean) {
      this.showFavoriteBtn = payload;
    },
    setShowFavoriteAnime(payload: boolean) {
      this.showFavoriteAnime = payload;
    },
    setPlayFavoriteOnAnime(payload: boolean) {
      this.playFavoriteOnAnime = payload;
    },
    setPlayFavoriteOffAnime(payload: boolean) {
      this.playFavoriteOffAnime = payload;
    },
    async FAVORITE_CHECKED(placeIdHash: string, callback: Function) {
      if (hasAccessToken()) {
        this.setIsFavoriteOn(true);
        this.setShowFavoriteAnime(true);
        this.setPlayFavoriteOnAnime(true);
        const result: boolean = await createFavoritePlace(placeIdHash).catch(() => false);
        // update failed
        if (!result) this.setIsFavoriteOn(false);

        // play animation
        setTimeout(() => {
          this.setShowFavoriteAnime(false);
          this.setPlayFavoriteOnAnime(false);
          callback();
        }, 1000);
      } else {
        this.$store.commit("ui/setFavoritePrompt", true);
      }
    },
    async FAVORITE_UNCHECKED(placeIdHash: string, callback: Function) {
      if (hasAccessToken()) {
        this.setIsFavoriteOn(false);
        this.setShowFavoriteAnime(true);
        this.setPlayFavoriteOffAnime(true);
        const result: boolean = await deleteFavoritePlace(placeIdHash).catch(() => false);
        // update failed
        if (!result) this.setIsFavoriteOn(true);

        // play animation
        setTimeout(() => {
          this.setShowFavoriteAnime(false);
          this.setPlayFavoriteOffAnime(false);
          callback();
        }, 1000);
      } else {
        this.$store.commit("ui/setFavoritePrompt", true);
      }
    },
    UPDATE_SORTED_PLACE_LIST(payload: { placeIdHash: string; status: boolean }) {
      const targetIndex: number = (
        this.$store.state.data.sortedPlaceList as portal.PublicPlaceWithVacancyId[]
      ).findIndex((place) => place.placeIdHash === payload.placeIdHash);
      if (targetIndex < 0) return;
      const targetPlace: portal.PublicPlaceWithVacancyId | undefined = (
        this.$store.state.data.sortedPlaceList as portal.PublicPlaceWithVacancyId[]
      ).find((place) => place.placeIdHash === payload.placeIdHash);
      if (targetPlace === undefined) return;
      targetPlace.isFavorite = payload.status;

      this.$store.commit("data/setSortedPlaceListIndex", {
        index: targetIndex,
        place: targetPlace,
      });
    },
    UPDATE_PLACE_LIST(payload: { placeIdHash: string; status: boolean }) {
      const targetIndex: number = (
        this.$store.state.data.placeList as PortalAdapterApi.ResponseGetPublicPlace[]
      ).findIndex((place) => place.placeIdHash === payload.placeIdHash);
      if (targetIndex < 0) return;
      const targetPlace: PortalAdapterApi.ResponseGetPublicPlace | undefined = (
        this.$store.state.data.placeList as PortalAdapterApi.ResponseGetPublicPlace[]
      ).find((place) => place.placeIdHash === payload.placeIdHash);
      if (targetPlace === undefined) return;
      targetPlace.isFavorite = payload.status;

      this.$store.commit("data/setPlaceListIndex", {
        index: targetIndex,
        place: targetPlace,
      });
    },
    CLEAR_ALL_FAVORITE_ON_PLACES() {
      const tmp: portal.PublicPlaceWithVacancyId = this.$store.state.data.sortedPlaceList?.map(
        (t: portal.PublicPlaceWithVacancyId) => {
          return {
            ...t,
            isFavorite: false,
          };
        },
      );
      // update virtual DOM
      this.$store.commit("data/setSortedPlaceList", []);
      this.$nextTick(() => {
        this.$store.commit("data/setSortedPlaceList", tmp);
      });
    },
  },
});
